<template lang="pug">
  div.p-date-interval
    div.p-date-interval__button
      p-button(
        :color="button.selected ? 'success' : 'primary'"
        size="xm"
        v-for="button in buttons"
        :key="button.id"
        @click="changeInterval(button)"
      )
        | {{ button.label }}
    <br/>
    div.p-date-interval__date-picker
      div.p-date-interval__date-picker--start
        p-date-picker(
          v-model="state.startDate"
          :name="`${name}-start`"
          :loading="loading"
          :disabled="disabled"
          label="Data inicial"
        )
      div.p-date-interval__date-picker--end
        p-date-picker(
          v-model="state.endDate"
          :name="`${name}-end`"
          :loading="loading"
          :disabled="disabled"
          label="Data final"
        )

</template>

<script>
import PButton from 'src/common/buttons/PButton.vue'
import PDatePicker from './PDatePicker.vue'

import { handlerUseStateVmodel } from '../mixins/handlerUseStateVmodel'

import moment from 'moment'

export default {
  name: 'PMultiRangeDates',
  components: {
    PButton,
    PDatePicker
  },
  mixins: [handlerUseStateVmodel()],
  data () {
    return {
      buttons: [
        {
          id: 1,
          label: 'Ontem',
          selected: false,
          startDate: moment().subtract(1, 'days').startOf('day').toDate(),
          endDate: moment().subtract(1, 'days').endOf('day').toDate()
        },
        {
          id: 2,
          label: 'Hoje',
          selected: false,
          startDate: moment().startOf('day').toDate(),
          endDate: moment().endOf('day').toDate()
        },
        {
          id: 3,
          label: 'Amanhã',
          selected: false,
          startDate: moment().add(1, 'days').startOf('day').toDate(),
          endDate: moment().add(1, 'days').endOf('day').toDate()
        },
        {
          id: 4,
          label: 'Semana Passada',
          selected: false,
          startDate: moment().startOf('week').subtract(7, 'days').startOf('day').toDate(),
          endDate: moment().startOf('week').subtract(1, 'days').endOf('day').toDate()
        },
        {
          id: 5,
          label: 'Essa Semana',
          selected: false,
          startDate: moment().startOf('week').startOf('day').toDate(),
          endDate: moment().startOf('week').add(6, 'days').endOf('day').toDate()
        },
        {
          id: 6,
          label: 'Próxima Semana',
          selected: false,
          startDate: moment().startOf('week').add(7, 'days').startOf('day').toDate(),
          endDate: moment().startOf('week').add(13, 'days').endOf('day').toDate()
        },
        {
          id: 7,
          label: 'Mês Passado',
          selected: false,
          startDate: moment().subtract(29, 'days').startOf('month').startOf('day').toDate(),
          endDate: moment().subtract(29, 'days').endOf('month').endOf('day').toDate()
        },
        {
          id: 8,
          label: 'Esse mês',
          selected: false,
          startDate: moment().startOf('month').startOf('day').toDate(),
          endDate: moment().endOf('month').endOf('day').toDate()
        },
        {
          id: 9,
          label: 'Próximo mês',
          selected: false,
          startDate: moment().add(29, 'days').startOf('month').startOf('day').toDate(),
          endDate: moment().add(29, 'days').endOf('month').endOf('day').toDate()
        }
      ]
    }
  },
  props: {
    disabled: Boolean,
    loading: Boolean,
    name: { type: String, required: true }
  },
  created () {},
  computed: {},
  watch: {},
  methods: {
    changeInterval (buttonSelected) {
      this.buttons.forEach(b => {
        b.selected = false
      })
      buttonSelected.selected = true

      const { startDate, endDate } = buttonSelected
      this.state.startDate = startDate
      this.state.endDate = endDate
    }
  }
}
</script>

<style scoped>
.p-date-interval {
  box-sizing: border-box;
  display: block;
}

.p-date-interval__button {
  display: flex;
  justify-content: center;
}

.p-date-interval__date-picker {
  display: flex;
  justify-content: space-around;
  margin-top: 5px;
  padding-top: 2px;
}
</style>
